"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    breadcrumbButtonClassNames: function() {
        return breadcrumbButtonClassNames;
    },
    useBreadcrumbButtonStyles_unstable: function() {
        return useBreadcrumbButtonStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _reactbutton = require("@fluentui/react-button");
const _reacttheme = require("@fluentui/react-theme");
const _reacticons = require("@fluentui/react-icons");
const breadcrumbButtonClassNames = {
    root: 'fui-BreadcrumbButton',
    icon: 'fui-BreadcrumbButton__icon'
};
/**
 * CSS variable names used internally for styling in the Breadcrumb.
 */ const breadcrumbCSSVars = {
    breadcrumbIconSizeVar: '--fui-Breadcrumb--icon-size',
    breadcrumbIconLineHeightVar: '--fui-Breadcrumb--icon-line-height'
};
const useIconStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        Be2twd7: "fsj74e5",
        Bqenvij: "f1qfv4wv",
        Bg96gwp: "f15xapk4",
        a9b677: "f17j33op",
        t21cq0: [
            "fm0x6gh",
            "fbyavb5"
        ]
    },
    small: {
        u3h8gg: "f1qfi7kw",
        Biu6dll: "f1876atl"
    },
    medium: {
        u3h8gg: "f1h9446d",
        Biu6dll: "f10xfswh"
    },
    large: {
        u3h8gg: "f5hcofs",
        Biu6dll: "f1a6v6zl"
    }
}, {
    d: [
        ".fsj74e5{font-size:var(--fui-Breadcrumb--icon-size);}",
        ".f1qfv4wv{height:var(--fui-Breadcrumb--icon-size);}",
        ".f15xapk4{line-height:var(--fui-Breadcrumb--icon-line-height);}",
        ".f17j33op{width:var(--fui-Breadcrumb--icon-size);}",
        ".fm0x6gh{margin-right:var(--spacingHorizontalXS);}",
        ".fbyavb5{margin-left:var(--spacingHorizontalXS);}",
        ".f1qfi7kw{--fui-Breadcrumb--icon-size:12px;}",
        ".f1876atl{--fui-Breadcrumb--icon-line-height:var(--lineHeightBase200);}",
        ".f1h9446d{--fui-Breadcrumb--icon-size:16px;}",
        ".f10xfswh{--fui-Breadcrumb--icon-line-height:var(--lineHeightBase400);}",
        ".f5hcofs{--fui-Breadcrumb--icon-size:20px;}",
        ".f1a6v6zl{--fui-Breadcrumb--icon-line-height:var(--lineHeightBase600);}"
    ]
});
const defaultButtonStyles = {
    backgroundColor: _reacttheme.tokens.colorTransparentBackground,
    color: _reacttheme.tokens.colorNeutralForeground2,
    cursor: 'auto'
};
const currentIconStyles = {
    ...defaultButtonStyles,
    [`& .${_reactbutton.buttonClassNames.icon}`]: {
        color: 'unset'
    },
    [`& .${_reacticons.iconFilledClassName}`]: {
        display: 'none'
    },
    [`& .${_reacticons.iconRegularClassName}`]: {
        display: 'inline'
    }
};
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bf4jedk: "f18p0k4z",
        j4b8c3: "fv6wr3j"
    },
    small: {
        Bqenvij: "frvgh55",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "figsok6",
        Bg96gwp: "fwrc4pm",
        z8tnut: "f16k8034",
        z189sj: [
            "fdw0yi8",
            "fk8j09s"
        ],
        Byoj8tv: "f1angvds",
        uwmqm3: [
            "fk8j09s",
            "fdw0yi8"
        ]
    },
    medium: {
        Bqenvij: "f1d2rq10",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi",
        z8tnut: "f16k8034",
        z189sj: [
            "fdw0yi8",
            "fk8j09s"
        ],
        Byoj8tv: "f1angvds",
        uwmqm3: [
            "fk8j09s",
            "fdw0yi8"
        ]
    },
    large: {
        Bqenvij: "fbhnoac",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "figsok6",
        Bg96gwp: "faaz57k",
        z8tnut: "f17mpqex",
        z189sj: [
            "f1vdfbxk",
            "f1f5gg8d"
        ],
        Byoj8tv: "fdvome7",
        uwmqm3: [
            "f1f5gg8d",
            "f1vdfbxk"
        ]
    },
    current: {
        Jwef8y: "f9ql6rf",
        Bi91k9c: "f3p8bqa",
        eoavqd: "f14w7a5u",
        Bbdnnc7: "f1irjp3o",
        Bk3fhr4: "f19vpps7",
        Bmfj8id: "fv5swzo",
        iro3zm: "f3h1zc4",
        B2d53fq: "f1xkgyln",
        c3iz72: "f17wbbfx",
        x3br3k: "fofxw0a",
        em6i61: "f1ol4fw6",
        vm6p8p: "f1q1lw4e",
        Bszkowt: "ff24m",
        Dyrjrp: "ft5r8e9",
        ezr58z: "f1cbpfqp",
        nhk3du: "f1motppv",
        Bfrek18: "fi9vkhg",
        G209fr: "f1fg3nnv"
    },
    currentSmall: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "fwrc4pm"
    },
    currentMedium: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "f1i3iumi"
    },
    currentLarge: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "faaz57k"
    }
}, {
    d: [
        ".f18p0k4z{min-width:unset;}",
        ".fv6wr3j{text-wrap:nowrap;}",
        ".frvgh55{height:24px;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".f16k8034{padding-top:var(--spacingHorizontalSNudge);}",
        ".fdw0yi8{padding-right:var(--spacingHorizontalSNudge);}",
        ".fk8j09s{padding-left:var(--spacingHorizontalSNudge);}",
        ".f1angvds{padding-bottom:var(--spacingHorizontalSNudge);}",
        ".f1d2rq10{height:32px;}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".fbhnoac{height:40px;}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}",
        ".f17mpqex{padding-top:var(--spacingHorizontalS);}",
        ".f1vdfbxk{padding-right:var(--spacingHorizontalS);}",
        ".f1f5gg8d{padding-left:var(--spacingHorizontalS);}",
        ".fdvome7{padding-bottom:var(--spacingHorizontalS);}",
        ".ff24m:disabled{background-color:var(--colorTransparentBackground);}",
        ".ft5r8e9:disabled{color:var(--colorNeutralForeground2);}",
        ".f1cbpfqp:disabled{cursor:auto;}",
        ".f1motppv:disabled .fui-Button__icon{color:unset;}",
        ".fi9vkhg:disabled .fui-Icon-filled{display:none;}",
        ".f1fg3nnv:disabled .fui-Icon-regular{display:inline;}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}"
    ],
    h: [
        ".f9ql6rf:hover{background-color:var(--colorTransparentBackground);}",
        ".f3p8bqa:hover{color:var(--colorNeutralForeground2);}",
        ".f14w7a5u:hover{cursor:auto;}",
        ".f1irjp3o:hover .fui-Button__icon{color:unset;}",
        ".f19vpps7:hover .fui-Icon-filled{display:none;}",
        ".fv5swzo:hover .fui-Icon-regular{display:inline;}",
        ".f3h1zc4:hover:active{background-color:var(--colorTransparentBackground);}",
        ".f1xkgyln:hover:active{color:var(--colorNeutralForeground2);}",
        ".f17wbbfx:hover:active{cursor:auto;}",
        ".fofxw0a:hover:active .fui-Button__icon{color:unset;}",
        ".f1ol4fw6:hover:active .fui-Icon-filled{display:none;}",
        ".f1q1lw4e:hover:active .fui-Icon-regular{display:inline;}"
    ]
});
const useBreadcrumbButtonStyles_unstable = (state)=>{
    const styles = useStyles();
    const iconStyles = useIconStyles();
    const currentSizeMap = {
        small: styles.currentSmall,
        medium: styles.currentMedium,
        large: styles.currentLarge
    };
    state.root.className = (0, _react.mergeClasses)(breadcrumbButtonClassNames.root, styles[state.size], styles.root, state.current && currentSizeMap[state.size], state.current && styles.current, state.root.className);
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(iconStyles.base, iconStyles[state.size], state.icon.className);
    }
    (0, _reactbutton.useButtonStyles_unstable)(state);
    return state;
}; //# sourceMappingURL=useBreadcrumbButtonStyles.styles.js.map
